import apiClient from "@/api/client";
import type {
  BacklogComment,
  BacklogEntry,
  BacklogEntryFormData,
  BacklogMember,
  BacklogVoteValue,
} from "../types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

const BASE = "/mgmt-backlog/";

export const backlogApi = {
  list: (params?: { status?: string; category?: string }) =>
    apiClient.get<{ data: BacklogEntry[] }>(BASE, { params }).then(wrap),

  members: () =>
    apiClient.get<{ data: BacklogMember[] }>(`${BASE}members/`).then(wrap),

  create: (data: BacklogEntryFormData) =>
    apiClient.post<{ data: BacklogEntry }>(BASE, data).then(wrap),

  update: (id: string, data: Partial<BacklogEntryFormData>) =>
    apiClient.patch<{ data: BacklogEntry }>(`${BASE}${id}/`, data).then(wrap),

  remove: (id: string) => apiClient.delete(`${BASE}${id}/`).then(() => undefined),

  vote: (id: string, value: BacklogVoteValue | null) =>
    apiClient.post<{ data: BacklogEntry }>(`${BASE}${id}/vote/`, { value }).then(wrap),

  assign: (id: string, data: { owner?: string; decision?: string }) =>
    apiClient.post<{ data: BacklogEntry }>(`${BASE}${id}/assign/`, data).then(wrap),

  complete: (id: string) =>
    apiClient.post<{ data: BacklogEntry }>(`${BASE}${id}/complete/`, {}).then(wrap),

  close: (id: string, decision: string) =>
    apiClient.post<{ data: BacklogEntry }>(`${BASE}${id}/close/`, { decision }).then(wrap),

  reopen: (id: string) =>
    apiClient.post<{ data: BacklogEntry }>(`${BASE}${id}/reopen/`, {}).then(wrap),

  comments: (id: string) =>
    apiClient.get<{ data: BacklogComment[] }>(`${BASE}${id}/comments/`).then(wrap),

  addComment: (id: string, content: string) =>
    apiClient
      .post<{ data: BacklogComment }>(`${BASE}${id}/comments/`, { content })
      .then(wrap),
};
